module.exports = __webpack_public_path__ + "public/0a5b2afca1aed20ad2a076f0df948852.ttf";